import AddAssignmentModal from './AddAssignmentModal';

export default AddAssignmentModal;
